export class UserUpgradeStatements {
  userUpgrades = [
    {
      toVersion: 1,
      statements: [
        `CREATE TABLE IF NOT EXISTS alteracoes (id TEXT PRIMARY KEY NOT NULL,tabela TEXT NOT NULL,  valor TEXT, excluir INTEGER);`,
        `CREATE TABLE IF NOT EXISTS pessoa (id TEXT PRIMARY KEY NOT NULL, nome TEXT NOT NULL, email TEXT, funcoes TEXT[], agencia_sigla TEXT NOT NULL);`,
        `CREATE TABLE IF NOT EXISTS projeto (id TEXT PRIMARY KEY NOT NULL, nome TEXT NOT NULL, agencia_sigla TEXT NOT NULL,
                                              inicio TEXT, fim TEXT, obs TEXT, localId TEXT, metodologias TEXT, campanhas TEXT, arquivos TEXT);`,
        `CREATE TABLE IF NOT EXISTS local (id TEXT PRIMARY KEY NOT NULL, agencia_sigla NOT NULL, nome TEXT NOT NULL, tipo TEXT, biomas TEXT, paiId TEXT);`,
        `CREATE TABLE IF NOT EXISTS bioma (id TEXT PRIMARY KEY NOT NULL, nome TEXT NOT NULL);`,
        `CREATE TABLE IF NOT EXISTS versao (nome TEXT PRIMARY KEY NOT NULL, versao TEXT NOT NULL, id TEXT);`,
        `CREATE TABLE IF NOT EXISTS taxon (id TEXT PRIMARY KEY NOT NULL, name  TEXT NOT NULL, rank TEXT, author TEXT,
                                          commonNames TEXT, status TEXT, grupo TEXT);`,
        `CREATE TABLE IF NOT EXISTS droga (id TEXT PRIMARY KEY NOT NULL, nome TEXT NOT NULL);`,
        `CREATE TABLE IF NOT EXISTS comportamento (id TEXT PRIMARY KEY NOT NULL, nome TEXT NOT NULL);`,
        `CREATE TABLE IF NOT EXISTS tipo_marcacao (id TEXT PRIMARY KEY NOT NULL, nome TEXT NOT NULL);`,
        `CREATE TABLE IF NOT EXISTS unidade_medida (id TEXT PRIMARY KEY NOT NULL, nome TEXT NOT NULL, sigla TEXT);`
      ],
    },
  ]
}
